import { FC, ReactNode, useMemo, useState } from 'react';
import {
  BreadcrumbsContext,
  BreadcrumbsContextType,
} from './breadcrumbs-context';

export type BreadcrumbsContextProviderProps = {
  children: ReactNode;
};

export const BreadcrumbsContextProvider: FC<
  BreadcrumbsContextProviderProps
> = ({ children }) => {
  const [titles, setTitles] = useState<BreadcrumbsContextType['titles']>({});

  const value = useMemo(() => ({ titles, setTitles }), [titles, setTitles]);

  return (
    <BreadcrumbsContext.Provider value={value}>
      {children}
    </BreadcrumbsContext.Provider>
  );
};
